<template>
  <div>
    <label
      v-if="titulo != 'hide'"
      v-bind:class="{
        'text-danger': current.errors && current.errors.tienda,
      }"
      >{{ titulo }}</label
    >
    <select
      v-bind:class="_class"
      style="width: 100%"
      autofocus="autofocus"
      required
      v-model="current.grupo"
      :disabled="isdisabled || disabled"
      @input="$emit('input', $event.target.value)"
      @change="$emit('change', $event.target.value)"
    >
      <option v-if="incluir_en_blanco" :value="null">Elije una categoría</option>
      <option v-for="_grupo in grupos" :key="_grupo.id" :value="_grupo.id">
        {{ _grupo.nombre }}
      </option>
    </select>
    <small v-if="current.errors && current.errors.grupo" class="form-text text-danger">{{
      current.errors.grupo[0]
    }}</small>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import DynamicService from "@/services/commons/DynamicService";

export default {
  props: {
    current: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
    desblock: {
      type: Boolean,
      required: false,
    },
    titulo: {
      type: String,
      default: "Categoría",
    },
    _class: {
      type: String,
      default: "form-control",
    },
    incluir_en_blanco: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      grupos: [],
    };
  },
  computed: {
    ...mapGetters({}),
    isdisabled: function () {
      let self = this;
      if (self.desblock == true) {
        return false;
      }
      if (self.current.estado != undefined) {
        return self.current.estado != "A";
      }
      return false;
    },
  },
  mounted() {
    this.refreshGrupos();
  },
  methods: {
    refreshGrupos() {
      let self = this;
      DynamicService.fetch("af", "grupo", {
        quitar_paginacion: true,
      }).then((res) => {
        self.grupos = res.data;
      });
    },
  },
};
</script>
